// Cart functionality for Vogal Theme

class CartManager {
  constructor() {
    this.cart = null;
    this.init();
  }

  async init() {
    await this.getCart();
    this.bindEvents();
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      this.updateCartUI();
      return this.cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async addToCart(id, quantity = 1, properties = {}) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity,
          properties: properties
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      await this.getCart();
      this.openCartDrawer();
      
      return await response.json();
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add item to cart');
    }
  }

  async updateCartItem(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      });

      await this.getCart();
      return await response.json();
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  async removeFromCart(line) {
    return await this.updateCartItem(line, 0);
  }

  updateCartUI() {
    // Update cart count
    const cartCount = document.querySelector('.cart-count-bubble');
    if (cartCount && this.cart) {
      cartCount.textContent = this.cart.item_count;
      cartCount.style.display = this.cart.item_count > 0 ? 'flex' : 'none';
    }

    // Update cart drawer items
    this.renderCartItems();
  }

  renderCartItems() {
    const cartItems = document.querySelector('.cart-drawer__items');
    const cartTotal = document.querySelector('.cart-drawer__total-price');
    
    if (!cartItems || !this.cart) return;

    if (this.cart.item_count === 0) {
      cartItems.innerHTML = '<p class="cart-empty">Your cart is empty</p>';
      if (cartTotal) cartTotal.textContent = '$0.00';
      return;
    }

    cartItems.innerHTML = this.cart.items.map((item, index) => `
      <div class="cart-item" data-line="${index + 1}">
        <div class="cart-item__image">
          <img src="${item.featured_image.url}" alt="${item.title}">
        </div>
        <div class="cart-item__details">
          <h4 class="cart-item__title">${item.product_title}</h4>
          <p class="cart-item__variant">${item.variant_title || ''}</p>
          <div class="cart-item__quantity">
            <button class="qty-btn qty-minus" data-line="${index + 1}">-</button>
            <input type="number" value="${item.quantity}" min="1" class="qty-input" data-line="${index + 1}">
            <button class="qty-btn qty-plus" data-line="${index + 1}">+</button>
          </div>
          <p class="cart-item__price">${this.formatMoney(item.final_line_price)}</p>
        </div>
        <button class="cart-item__remove" data-line="${index + 1}">&times;</button>
      </div>
    `).join('');

    if (cartTotal) {
      cartTotal.textContent = this.formatMoney(this.cart.total_price);
    }

    this.bindCartItemEvents();
  }

  bindCartItemEvents() {
    // Quantity buttons
    document.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const line = parseInt(e.target.dataset.line);
        const input = document.querySelector(`.qty-input[data-line="${line}"]`);
        const currentQty = parseInt(input.value);
        if (currentQty > 1) {
          this.updateCartItem(line, currentQty - 1);
        }
      });
    });

    document.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const line = parseInt(e.target.dataset.line);
        const input = document.querySelector(`.qty-input[data-line="${line}"]`);
        const currentQty = parseInt(input.value);
        this.updateCartItem(line, currentQty + 1);
      });
    });

    // Remove buttons
    document.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const line = parseInt(e.target.dataset.line);
        this.removeFromCart(line);
      });
    });

    // Quantity inputs
    document.querySelectorAll('.qty-input').forEach(input => {
      input.addEventListener('change', (e) => {
        const line = parseInt(e.target.dataset.line);
        const quantity = parseInt(e.target.value);
        if (quantity > 0) {
          this.updateCartItem(line, quantity);
        }
      });
    });
  }

  bindEvents() {
    // Add to cart buttons
    document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        const quantity = parseInt(btn.dataset.quantity || 1);
        
        btn.disabled = true;
        btn.textContent = 'Adding...';
        
        await this.addToCart(variantId, quantity);
        
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
    });
  }

  openCartDrawer() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-drawer__overlay');
    
    if (drawer && overlay) {
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return `$${amount.toFixed(2)}`;
  }
}

// Initialize cart manager
if (typeof window !== 'undefined') {
  window.cartManager = new CartManager();
}

